import React from 'react'
import { useExercise } from '../ExerciseProvider'
import PartOne from './PartOne'
import PartTwo from './PartTwo'
import PartThree from './PartThree'

const DiscoveringYourConsultingNiche = () => {
  const { exerciseIndex } = useExercise()
  return (
    <div>
      {exerciseIndex === 0 && <PartOne />}
      {exerciseIndex === 1 && <PartTwo />}
      {exerciseIndex === 2 && <PartThree />}
    </div>
  )
}

export default DiscoveringYourConsultingNiche

export const TextArea = ({ slug, ...props }) => {
  const { exerciseIndex, getResponse, handleChange } = useExercise()

  const handleTextChange = (e) => {
    handleChange(exerciseIndex, slug, e)
  }

  const textResponse = getResponse(exerciseIndex, slug) || ''

  return (
    <textarea
      className="min-h-[125px] w-full rounded-[20px] border border-[#D3D3D3] bg-[#F7FAFC] p-3 font-roboto text-base"
      onChange={handleTextChange}
      value={textResponse}
      {...props}
    />
  )
}
